import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import {
  fetchAndSignMondayData,
  fetchInit,
  fetchMondayContext,
  selectMondayAccountId,
  selectMondayState,
} from "@state/mondaySlice";
import type { AppDispatch } from "@state/store";

export const useAppInitialization = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [initialized, setInitialized] = useState(false);

  // prettier-ignore
  const { error, isTrial, isActive, hasPaidSubscription, init, subscription, context } = useSelector(selectMondayState);
  const { role, stage } = init;
  const isGuestOrViewOnlyUser = context?.user.isGuest || context?.user.isViewOnly;
  const mondayAccountId = useSelector(selectMondayAccountId);

  useEffect(() => {
    async function initializeApp() {
      try {
        await dispatch(fetchMondayContext()).unwrap();
        await dispatch(fetchInit({})).unwrap();
        await dispatch(fetchAndSignMondayData()).unwrap();

        setInitialized(true);
      } catch {
        setInitialized(true);
      }
    }

    if (!initialized) {
      initializeApp();
    }
  }, [dispatch, initialized]);

  return {
    stage,
    role,
    isActive,
    isTrial,
    hasPaidSubscription,
    daysLeft: subscription?.days_left,
    isLoading: !initialized,
    error,
    mondayAccountId,
    isGuestOrViewOnlyUser,
  };
};
